'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPurchasedProductsHistoryByAccount = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * getProductsHistory
 *
 * Fetches a historical list of products purchased by an account.
 * @param {String} feis_id
 * @param {String} acct_id
 */
var getPurchasedProductsHistoryByAccount = exports.getPurchasedProductsHistoryByAccount = function getPurchasedProductsHistoryByAccount(feis_id, pid) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      pid: pid

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/persons/' + pid + '/purchases-history'
      },
      types: ['GET_PURCHASED_PRODUCTS_HISTORY_BY_ACCOUNT_FOR_FEIS_START', 'GET_PURCHASED_PRODUCTS_HISTORY_BY_ACCOUNT_FOR_FEIS', 'GET_PURCHASED_PRODUCTS_HISTORY_BY_ACCOUNT_FOR_FEIS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getPurchasedProductsHistoryByAccount.js
// module id = 663
// module chunks = 0